import { QueryConfig } from "store/utils/query-config";

export const fbPostsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdTime"]
  }
};
